<template>
  <div class="col-sm-12">

    <div class="card">

      <!-- Search + Add -->
      <div class="dropdown-item page-item">

        <div class="page-grid">

          <!-- Search -->
          <div class="page-search-container dropdown-item">

            <input
              type="text"
              placeholder="Search parameters by name or value"
              class="search-input"
              v-model="searchFilter"
            />

          </div>

          <!-- Create -->
          <button
            type="button"
            class="btn button-default new-item-btn"
            @click="addNewParameter"
          >
            Add New Parameter
          </button>

        </div>

      </div>


      <!-- Loading -->
      <div
        v-if="loading"
        class="loading-spinner"
      >
        <i class="fa fa-spinner fa-spin"></i>
        Loading...
      </div>


      <!-- Table -->
      <div
        class="table-responsive"
        v-if="
          !loading &&
          systemParameterList.length > 0
        "
      >

        <table class="table">

          <thead>

            <tr class="border-bottom-primary">

              <th scope="col">
                Parameter Name
              </th>

              <th scope="col">
                Parameter Value
              </th>

              <th scope="col">
                Status
              </th>

              <th scope="col">
                Actions
              </th>

            </tr>

          </thead>


          <tbody>

            <tr
              v-for="parameter in filteredParameters"
              :key="parameter.id"
            >

              <!-- Parameter Name -->
              <td>
                {{ parameter.param_name }}
              </td>


              <!-- Parameter Value -->
              <td class="parameter-value">

                {{
                  parameter.param_value !== null &&
                  parameter.param_value !== ""
                    ? parameter.param_value
                    : "-"
                }}

              </td>


              <!-- Status -->
              <td>

                <span
                  :class="{
                    'status-label status-yes':
                      parameter.is_active == 1,

                    'status-label status-no':
                      parameter.is_active == 0
                  }"
                >

                  {{
                    parameter.is_active == 1
                      ? "Active"
                      : "Inactive"
                  }}

                </span>

              </td>


              <!-- Actions -->
              <td>

                <div class="action-icons">

                  <i
                    class="fa fa-edit action-icon edit-icon"
                    title="Edit"
                    @click="editDetails(parameter.id)"
                  ></i>

                </div>

              </td>

            </tr>


            <!-- Search empty -->
            <tr
              v-if="
                filteredParameters.length === 0
              "
            >

              <td
                colspan="4"
                class="text-center"
              >
                No system parameters found matching your search
              </td>

            </tr>

          </tbody>

        </table>

      </div>


      <!-- No records -->
      <div
        v-else-if="
          !loading &&
          systemParameterList.length === 0
        "
        class="no-data-message"
      >
        No system parameters found.
      </div>

    </div>

  </div>
</template>


<script>
import { useRouter } from "vue-router";

import {
  getSystemParameterList
} from "@/services/dataService";

import { useToast } from "vue-toastification";


export default {

  name: "SystemParametersManagementForm",


  data() {

    return {

      loading: false,

      token:
        localStorage.getItem("token_set") || "",

      systemParameterList: [],

      searchFilter: ""

    };

  },


  computed: {

    filteredParameters() {

      const search =
        this.searchFilter
          .toLowerCase()
          .trim();


      if (!search) {

        return this.systemParameterList;

      }


      return this.systemParameterList.filter(
        parameter => {

          const parameterName =
            String(
              parameter.param_name || ""
            ).toLowerCase();


          const parameterValue =
            String(
              parameter.param_value ?? ""
            ).toLowerCase();


          const status =
            parameter.is_active == 1
              ? "active"
              : "inactive";


          return (
            parameterName.includes(search) ||
            parameterValue.includes(search) ||
            status.includes(search)
          );

        }
      );

    }

  },


  methods: {

    async getSystemParameters() {

      try {

        this.loading = true;


        const response =
          await getSystemParameterList(
            this.token
          );


        if (
          response.data?.status ===
          "success"
        ) {

          this.systemParameterList =
            response.data?.data || [];

        } else {

          this.systemParameterList = [];

          this.toast.error(
            response.data?.message ||
            "Failed to load system parameters."
          );

        }

      } catch (error) {

        console.error(
          "Error fetching system parameters:",
          error
        );


        this.systemParameterList = [];


        this.toast.error(
          error.response?.data?.message ||
          "Failed to load system parameters."
        );

      } finally {

        this.loading = false;

      }

    },


    addNewParameter() {

      this.$router.push({
        path: "/add-system-parameter"
      });

    },


    editDetails(id) {

      this.$router.push({
        path: `/add-system-parameter/${id}`
      });

    }

  },


  setup() {

    const router =
      useRouter();

    const toast =
      useToast();


    return {
      router,
      toast
    };

  },


  mounted() {

    this.getSystemParameters();

  }

};
</script>


<style scoped lang="scss">

.page-grid {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 15px;
}

.page-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}

.page-search-container {
  display: flex;
  align-items: center;
  flex-grow: 1;
}

.search-input {
  padding: 10px;

  border-radius: 5px;

  border: 1px solid #ccc;

  font-size: 14px;

  transition:
    border-color 0.3s,
    box-shadow 0.3s;

  width: 100%;

  min-width: 250px;
}

.search-input:hover {
  border-color: #0056b3;
}

.search-input:focus {
  border-color: #007bff;

  box-shadow:
    0 0 5px
    rgba(38, 143, 255, 0.5);

  outline: none;
}

.new-item-btn {
  margin-left: auto;
  padding: 10px 20px;
  white-space: nowrap;
  flex-shrink: 0;
}

.card {
  padding: 10px;
}

.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
  padding-bottom: 20px;
  color: #007bff;
}

.parameter-value {
  max-width: 500px;
  word-break: break-word;
}

.status-label {
  display: inline-block;

  padding: 4px 12px;

  border-radius: 5px;

  font-size: 0.75rem;

  text-transform: uppercase;

  letter-spacing: 0.5px;

  min-width: 90px;

  max-width: 90px;

  text-align: center;
}

.status-yes {
  background-color: #069E27;
  color: #fff;
  border-radius: 4px;
}

.status-no {
  background-color: red;
  color: #fff;
  border-radius: 4px;
}

.action-icons {
  display: flex;
  align-items: center;
  gap: 15px;
}

.action-icon {
  cursor: pointer;

  font-size: 16px;

  transition:
    color 0.3s,
    transform 0.3s;
}

.edit-icon {
  color: #007bff;
}

.edit-icon:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.no-data-message {
  text-align: center;
  padding: 20px;
  color: #6c757d;
  font-style: italic;
}

.text-center {
  text-align: center;
}

.button-default {
  color: #fff;
  background-color: #007bff;
  border-color: #007bff;
}

.button-default:hover {
  color: #fff;
  background-color: #0056b3;
  border-color: #004085;
}


@media (max-width: 768px) {

  .page-grid {
    flex-direction: column;
    gap: 10px;
    align-items: stretch;
  }

  .page-search-container {
    width: 100%;
  }

  .search-input {
    min-width: 100%;
  }

  .new-item-btn {
    margin-left: 0;
    width: 100%;
  }

}
</style>